import { render } from "./customButton.vue?vue&type=template&id=791ff91c&scoped=true"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"

import "./customButton.vue?vue&type=style&index=0&id=791ff91c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791ff91c"]])

export default __exports__